var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankWithPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13529 21.2961V10.5635H20.1663V21.2773C20.1663 21.3523 20.1663 21.4273 20.1663 21.4929C20.1663 21.596 20.1847 21.6804 20.0561 21.6804C19.1283 21.6804 18.2097 21.6804 17.2819 21.6804H4.10902C3.81506 21.6804 3.53029 21.6804 3.23634 21.6804C3.10773 21.6804 3.13529 21.6148 3.13529 21.5023V21.3055V21.2961Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0143 9.00698V10.1631C22.0143 10.3855 21.8122 10.5633 21.5734 10.5633H1.87843C1.63041 10.5633 1.4375 10.3855 1.4375 10.1631V9.00698C1.4375 8.86468 1.52017 8.74017 1.64878 8.66903L11.4963 3.04831C11.6432 2.96827 11.827 2.96827 11.9647 3.04831L21.8122 8.66903C21.9408 8.74017 22.0235 8.87358 22.0235 9.00698H22.0143Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4047 21.6699H1.19531",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.582V21.6053",
    stroke: "#3876BB",
    strokeWidth: 1.32934
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.582V21.6053",
    stroke: "#3876BB",
    strokeWidth: 1.32934
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.584,
    r: 6,
    fill: "#EBF1F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2969 15.584V22.1765",
    stroke: "#3876BB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 18.8799H15.0012",
    stroke: "#3876BB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankWithPlusIcon);
export default __webpack_public_path__ + "static/media/BankWithPlusIcon.c2a4e8338b39d4e2738299070f5fcafc.svg";
export { ForwardRef as ReactComponent };